import ApiService from "../api";

export default class EntregaService extends ApiService {

    constructor() {
        super("/api/entregas");
    }

    importarExcel(data) {
        return this.post(`/upload`, data)
    }
}
